import { render, staticRenderFns } from "./RegisterSchedule.vue?vue&type=template&id=872b91f0&"
import script from "./RegisterSchedule.vue?vue&type=script&lang=js&"
export * from "./RegisterSchedule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports